import React, { useState, useRef } from 'react';
import './styles.css';

const SwpsNews = ({ 
  formId, 
  emailFieldId, 
  apiEndpoint,
  siteName,
  site
}) => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formRef = useRef(null);

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    
    if (!email) {
      setMessage("Please enter your email address");
      setStatus("error");
      return;
    }
    
    // Simple email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      setMessage("Please enter a valid email address");
      setStatus("error");
      return;
    }
    
    try {
      setIsSubmitting(true);
      
      const siteId = site || (siteName && siteName.toLowerCase() === 'aeroe' ? 'aeroe' : 'nockpool');
      
      const formData = new FormData();
      formData.append("email", email);
      formData.append("formId", formId);
      formData.append("emailFieldId", emailFieldId);
      formData.append("site", siteId);
      
      const response = await fetch(apiEndpoint, {
        method: "POST",
        body: formData
      });
      
      if (!response.ok) {
        let errorMessage = "Submission failed";
        try {
          const errorData = await response.json();
          errorMessage = errorData?.message || errorMessage;
        } catch (e) {
          console.error("Failed to parse error response:", e);
        }
        throw new Error(errorMessage);
      }
      
      const data = await response.json();
      
      setMessage(data.message || `We've sent you a confirmation link -- check spam if you don't see it in your inbox.`);
      setStatus("success");
      setEmail("");
      
    } catch (error) {
      setMessage(error.message || "An error occurred. Please try again or reach out to howdy@swps.io");
      setStatus("error");
      console.error("Submission error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="newsletter-component">
      <h1>Hear about it first</h1>
      
      {message && (
        <div className={`message-display ${status}`}>
          {message}
        </div>
      )}
      
      {/* Only show the form if we don't have a successful submission */}
      {status !== "success" && (
        <div className="form-wrapper" ref={formRef}>
          <div className="input-group">
            <input
              type="email"
              id="user-email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="email-input"
            />
          </div>
          
          <button
            onClick={handleSubmit}
            disabled={isSubmitting}
            className="submit-btn"
          >
            {isSubmitting ? "Submitting..." : "Subscribe"}
          </button>
        </div>
      )}
    </div>
  );
};

export default SwpsNews;